import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";

const clearLegacyPwaCaches = async () => {
  let hasLegacyArtifacts = false;

  if ("serviceWorker" in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      if (registrations.length > 0) {
        hasLegacyArtifacts = true;
      }
      await Promise.all(registrations.map(registration => registration.unregister()));
    } catch (_err) {
      // ignore
    }
  }

  if ("caches" in window) {
    try {
      const keys = await caches.keys();
      const legacyKeys = keys.filter(key => {
        const normalized = key.toLowerCase();
        return (
          normalized.includes("workbox") ||
          normalized.includes("precache") ||
          normalized.includes("whaticket")
        );
      });

      if (legacyKeys.length > 0) {
        hasLegacyArtifacts = true;
      }

      await Promise.all(
        legacyKeys.map(key => caches.delete(key))
      );
    } catch (_err) {
      // ignore
    }
  }

  return hasLegacyArtifacts;
};

const renderApp = () => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(<App />);
};

const bootstrap = async () => {
  await clearLegacyPwaCaches();
  renderApp();
};

bootstrap();
